import { AssignmentPlatform } from "refsix-core";
import { isAndroid, isIos } from "../../../services/platformDetection";
import { inAppBrowserIsMocked } from "../../../services/assignments/mockInAppBrowser";

/**
 * Whether this device can run the import: it needs the native WebView, and a
 * platform whose sign-in works inside one (`inAppImport`).
 *
 * Also true on the web when the InAppBrowser stand-in is installed, which is
 * the only way Cypress can reach this path — see mockInAppBrowser.ts.
 *
 * Every card that talks about the import reads this, so a desktop browser
 * cannot be told to tap a button it has not been given.
 */
export function canImportInApp(platform: AssignmentPlatform): boolean {
    const onDevice = isIos() || isAndroid();
    return (onDevice || inAppBrowserIsMocked()) && platform.inAppImport;
}
